import { makeStyles } from "@material-ui/core";
import React, { useState, useRef, useEffect } from "react";
import { useSelector } from "react-redux";
import Alert from "@material-ui/lab/Alert";
import Backdrop from "@material-ui/core/Backdrop";
import CircularProgress from "@material-ui/core/CircularProgress";
import { cloudFunctions, auth } from "../../firebase";

function useInterval(callback, delay) {
    const savedCallback = useRef();
  
    // Remember the latest callback.
    useEffect(() => {
      savedCallback.current = callback;
    }, [callback]);
  
    // Set up the interval.
    useEffect(() => {
      let id = setInterval(() => {
        savedCallback.current();
      }, delay);
      return () => clearInterval(id);
    }, [delay]);
  }

const useStyles = makeStyles((theme) => ({
    alert: {
      margin: "10px 0px",
      width: "100%",
    },
  }));

export default function PayPal() {
    const { newUser = {}} = useSelector((state) => ({
        newUser: state.newUser
      }));
    const classes = useStyles()
    const paypalRef = React.useRef();
    const [loading, setLoading] = useState(false);
    const [success, setSuccess] = useState(false);
    const [cardError, setCardError] = useState(null);
    const [errorMessage, setErrorMessage] = useState(null);
    
    const [counter, setcounter] = useState(5);

    // To show PayPal buttons once the component loads
    React.useEffect(() => {
        window.paypal
            .Buttons({
                createSubscription: (data, actions) => {
                    return actions.subscription.create({
                        //'plan_id': "P-22D79228FY306192SMFPXG4Q",
                        'plan_id': "P-9LJ69293LJ531092AMF5VM4Y",
                    });
                },
                onApprove: async (data, actions) => {
                    setLoading(true)
                    const createPayPalSubscription = cloudFunctions.httpsCallable(
                        "createPayPalSubscription"
                    );
                    createPayPalSubscription({
                        ...data, userId: newUser.uid
                    }).then(async (res) => {
                        if (newUser.password) {
                            await auth.signInWithEmailAndPassword(
                              newUser.email,
                              newUser.password
                            );
                          }
                        setLoading(false)
                        setSuccess(true)
                    }).catch(err => {
                        setLoading(false)
                        setLoading(false);
                        setErrorMessage(err.message);
                    })
                },
                onError: (err) => {
                    setCardError(err);
                },
            })
            .render(paypalRef.current);
    }, []);

    useInterval(() => {
        if (success) {
          setcounter(counter - 1);
        }
      }, 1000);
    
    useEffect(() => {
      if (counter <= 0) {
        window.location.reload();
      }
    }, [counter]);

    return (
        <div>
            <Backdrop open={loading} style={{ zIndex: 10000 }}>
                <CircularProgress style={{ width: 30, height: 30 }} color="inherit" />
            </Backdrop>
            {success && (
            <Alert className={classes.alert} severity="success">
                The payment method has been successfully updated, you will be redirected to home page in {counter} seconds
            </Alert>
            )}
            {errorMessage !== null && (
            <Alert className={classes.alert} severity="error">
                {errorMessage}
            </Alert>
            )}
            {cardError !== null && (
            <Alert className={classes.alert} severity="error">
                {cardError}
            </Alert>
            )}
            {!success && <div ref={paypalRef} />}
        </div>
    );
}